export class AbstractKicadImporter {
    moduleData;
    constructor(moduleData) {
        this.moduleData = moduleData;
    }
}
//# sourceMappingURL=AbstractKicadImporter.js.map